// extracted by mini-css-extract-plugin
export default {"container":"BND14u","replyToLabel":"J5uUPf","replyToMember":"Qn6sTd","memberName":"mzBN9e","tooltip":"ffnC8N"};